import { Arbre, ArbreAddressUpdateInput, ArbreCoordinateUpdateInput, ArbreCreateInput, ArbreListResponse, ArbreResponse, ArbreSelectInput, ArbreUpdateInput } from '@repo/types';
import { AxiosInstance } from 'axios';
import { axiosInstance } from '../axios-instance';
import { ENDPOINTS } from '../endpoint';
import { BaseApiService } from './base-api.service';

export class ArbreService extends BaseApiService {
  constructor(axios: AxiosInstance = axiosInstance) {
    super(ENDPOINTS.ARBRES.BASE, axios);
  }

  async getArbres(filters: ArbreSelectInput): Promise<ArbreListResponse> {
    const { page = 1, limit = 10, ...rest } = filters as any;
    return this.getPaginated<Arbre>({ page, limit, ...rest });
  }

  async getArbreById(id: number): Promise<ArbreResponse> {
    return this.get<ArbreResponse>(`/${id}`);
  }

  async createArbre(data: ArbreCreateInput): Promise<Arbre> {
    const res = await this.post<ArbreResponse, ArbreCreateInput>('', data);
    return res.data;
  }

  async updateArbre(id: number, data: ArbreUpdateInput): Promise<ArbreResponse> {
    return this.put<ArbreResponse, ArbreUpdateInput>(`/${id}`, data);
  }

  async updateCoordinates(id: number, data: ArbreCoordinateUpdateInput): Promise<ArbreResponse> {
    return this.patch<ArbreResponse, ArbreCoordinateUpdateInput>(`/${id}/coordinates`, data);
  }

  async updateAddress(id: number, data: ArbreAddressUpdateInput): Promise<ArbreResponse> {
    return this.patch<ArbreResponse, ArbreAddressUpdateInput>(`/${id}/address`, data);
  }

  async deleteArbre(id: number): Promise<ArbreResponse> {
    return this.delete<ArbreResponse>(`/${id}`);
  }

  async updateImage(id: number, field: 'img1' | 'img2' | 'img3', file: File): Promise<ArbreResponse> {
    const formData = new FormData();
    formData.append('image', file);

    return this.axios.patch<ArbreResponse>(
      `${this.endpoint}/${id}/update-image/${field}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    ).then(response => response.data);
  }

  async deleteImage(id: number, field: 'img1' | 'img2' | 'img3'): Promise<ArbreResponse> {
    return this.axios.delete<ArbreResponse>(
      `${this.endpoint}/${id}/delete-image/${field}`
    ).then(response => response.data);
  }

  async rotateImage(id: number, field: 'img1' | 'img2' | 'img3', rotation: number): Promise<ArbreResponse> {
    return this.axios.patch<ArbreResponse>(
      `${this.endpoint}/${id}/rotate-image/${field}`,
      { rotation }
    ).then(response => response.data);
  }

  async updateStatusTravaux(ids: number[], status_travaux: boolean): Promise<void> {
    await this.axios.post(ENDPOINTS.ARBRES.UPDATE_STATUS_TRAVAUX, { ids, status_travaux });
  }

  /** « Action réalisée » → Visite (séparée du statut des travaux). */
  async updateStatusVisite(ids: number[], status_visite: boolean): Promise<void> {
    await this.axios.post(ENDPOINTS.ARBRES.UPDATE_STATUS_VISITE, { ids, status_visite });
  }
}


